<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams"  [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"


[rowCanExpand]="true"
>
    <ng-container topToolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>

  <ng-container filters>
    <div class="fieldsetsContainer" [formGroup]="formGroup">
      <div class="fieldsetsGroup">
      <div data-cy="field-id-date_from" *ngIf="!filters.date_from.hidden && !filters.date_from.removed" 
            class="field-container standard {{filters.date_from.invalid ? 'invalid' : ''}} {{filters.date_from.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.date_from.styles.style"
            [ngClass]="filters.date_from.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.date_from.label + (filters.date_from.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.date_from.label}}<span *ngIf="filters.date_from.required" class="required-asterisk">*</span>
          </label>
        </div>
        <app-datebox 
            data-cy="dateBox"
            formControlName="date_from"
            [format]="filters.date_from.control.format"
            [mode]="filters.date_from.control.mode"
            [ngStyle]="filters.date_from.control.styles.style"
            [ngClass]="filters.date_from.control.styles.classes"
            [tooltip]="filters.date_from.control.tooltip">
        </app-datebox>
        <ng-container *ngIf="filters.date_from.invalid">
          <ng-container *ngFor="let error of filters.date_from.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-date_to" *ngIf="!filters.date_to.hidden && !filters.date_to.removed" 
            class="field-container standard {{filters.date_to.invalid ? 'invalid' : ''}} {{filters.date_to.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.date_to.styles.style"
            [ngClass]="filters.date_to.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.date_to.label + (filters.date_to.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.date_to.label}}<span *ngIf="filters.date_to.required" class="required-asterisk">*</span>
          </label>
        </div>
        <app-datebox 
            data-cy="dateBox"
            formControlName="date_to"
            [format]="filters.date_to.control.format"
            [mode]="filters.date_to.control.mode"
            [ngStyle]="filters.date_to.control.styles.style"
            [ngClass]="filters.date_to.control.styles.classes"
            [tooltip]="filters.date_to.control.tooltip">
        </app-datebox>
        <ng-container *ngIf="filters.date_to.invalid">
          <ng-container *ngFor="let error of filters.date_to.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-date_type" *ngIf="!filters.date_type.hidden && !filters.date_type.removed" 
            class="field-container standard {{filters.date_type.invalid ? 'invalid' : ''}} {{filters.date_type.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.date_type.styles.style"
            [ngClass]="filters.date_type.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.date_type.label + (filters.date_type.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.date_type.label}}<span *ngIf="filters.date_type.required" class="required-asterisk">*</span>
          </label>
        </div>
        <ShippingContainers-task_dates_dd_single 
            data-cy="selector"
            [type]="filters.date_type.control.type"
            formControlName="date_type"
            (displayTextChange)="filters.date_type.control.displayText=$event"
            [placeholder]="filters.date_type.control.placeholder"
            [styles]="filters.date_type.control.styles"
            [tooltip]="filters.date_type.control.tooltip"
        >
        </ShippingContainers-task_dates_dd_single>
        <ng-container *ngIf="filters.date_type.invalid">
          <ng-container *ngFor="let error of filters.date_type.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-operation_code" *ngIf="!filters.operation_code.hidden && !filters.operation_code.removed" 
            class="field-container standard {{filters.operation_code.invalid ? 'invalid' : ''}} {{filters.operation_code.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.operation_code.styles.style"
            [ngClass]="filters.operation_code.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.operation_code.label + (filters.operation_code.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.operation_code.label}}<span *ngIf="filters.operation_code.required" class="required-asterisk">*</span>
          </label>
        </div>
        <Inventory-operationcodes_dd_multi 
            data-cy="selector-multi"
            [type]="filters.operation_code.control.type"
            formControlName="operation_code"
            (displayTextChange)="filters.operation_code.control.displayText=$event"
            [placeholder]="filters.operation_code.control.placeholder"
            [styles]="filters.operation_code.control.styles"
            [tooltip]="filters.operation_code.control.tooltip"
        >
        </Inventory-operationcodes_dd_multi>
        <ng-container *ngIf="filters.operation_code.invalid">
          <ng-container *ngFor="let error of filters.operation_code.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-status" *ngIf="!filters.status.hidden && !filters.status.removed" 
            class="field-container standard {{filters.status.invalid ? 'invalid' : ''}} {{filters.status.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.status.styles.style"
            [ngClass]="filters.status.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.status.label + (filters.status.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.status.label}}<span *ngIf="filters.status.required" class="required-asterisk">*</span>
          </label>
        </div>
        <Inventory-task_statuses_dd_multi 
            data-cy="selector-multi"
            [type]="filters.status.control.type"
            formControlName="status"
            (displayTextChange)="filters.status.control.displayText=$event"
            [placeholder]="filters.status.control.placeholder"
            [styles]="filters.status.control.styles"
            [tooltip]="filters.status.control.tooltip"
        >
        </Inventory-task_statuses_dd_multi>
        <ng-container *ngIf="filters.status.invalid">
          <ng-container *ngFor="let error of filters.status.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      </div>
    </div>
  </ng-container>

  <ng-container gridColumnDef="Id">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Id.displayControl.styles.style"
          [ngClass]="row.cells.Id.displayControl.styles.classes"
          [matTooltip]="row.cells.Id.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Id.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="OperationCode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.OperationCode.displayControl.styles.style"
          [ngClass]="row.cells.OperationCode.displayControl.styles.classes"
          [matTooltip]="row.cells.OperationCode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.OperationCode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Status">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Status.displayControl.styles.style"
          [ngClass]="row.cells.Status.displayControl.styles.classes"
          [matTooltip]="row.cells.Status.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Status.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Owner">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Owner.displayControl.styles.style"
          [ngClass]="row.cells.Owner.displayControl.styles.classes"
          [matTooltip]="row.cells.Owner.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Owner.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Project">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Project.displayControl.styles.style"
          [ngClass]="row.cells.Project.displayControl.styles.classes"
          [matTooltip]="row.cells.Project.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Project.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Material">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Material.displayControl.styles.style"
          [ngClass]="row.cells.Material.displayControl.styles.classes"
          [matTooltip]="row.cells.Material.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Material.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="VendorLot">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.VendorLot.displayControl.styles.style"
          [ngClass]="row.cells.VendorLot.displayControl.styles.classes"
          [matTooltip]="row.cells.VendorLot.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.VendorLot.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Lot">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Lot.displayControl.styles.style"
          [ngClass]="row.cells.Lot.displayControl.styles.classes"
          [matTooltip]="row.cells.Lot.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Lot.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ActualSourceShippingContainer">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ActualSourceShippingContainer.displayControl.styles.style"
          [ngClass]="row.cells.ActualSourceShippingContainer.displayControl.styles.classes"
          [matTooltip]="row.cells.ActualSourceShippingContainer.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ActualSourceShippingContainer.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ActualTargetShippingContainer">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ActualTargetShippingContainer.displayControl.styles.style"
          [ngClass]="row.cells.ActualTargetShippingContainer.displayControl.styles.classes"
          [matTooltip]="row.cells.ActualTargetShippingContainer.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ActualTargetShippingContainer.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ExpectedSourceShippingContainer">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ExpectedSourceShippingContainer.displayControl.styles.style"
          [ngClass]="row.cells.ExpectedSourceShippingContainer.displayControl.styles.classes"
          [matTooltip]="row.cells.ExpectedSourceShippingContainer.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ExpectedSourceShippingContainer.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ExpectedTargetShippingContainer">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ExpectedTargetShippingContainer.displayControl.styles.style"
          [ngClass]="row.cells.ExpectedTargetShippingContainer.displayControl.styles.classes"
          [matTooltip]="row.cells.ExpectedTargetShippingContainer.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ExpectedTargetShippingContainer.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="OrderLookupCode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.OrderLookupCode.displayControl.styles.style"
          [ngClass]="row.cells.OrderLookupCode.displayControl.styles.classes"
          [matTooltip]="row.cells.OrderLookupCode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.OrderLookupCode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="LoadContainerLookupCode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.LoadContainerLookupCode.displayControl.styles.style"
          [ngClass]="row.cells.LoadContainerLookupCode.displayControl.styles.classes"
          [matTooltip]="row.cells.LoadContainerLookupCode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.LoadContainerLookupCode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="StartDateTime">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.StartDateTime.displayControl.styles.style"
          [ngClass]="row.cells.StartDateTime.displayControl.styles.classes"
          [matTooltip]="row.cells.StartDateTime.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.StartDateTime.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="CompletedDateTime">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.CompletedDateTime.displayControl.styles.style"
          [ngClass]="row.cells.CompletedDateTime.displayControl.styles.classes"
          [matTooltip]="row.cells.CompletedDateTime.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.CompletedDateTime.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Employee">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Employee.displayControl.styles.style"
          [ngClass]="row.cells.Employee.displayControl.styles.classes"
          [matTooltip]="row.cells.Employee.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Employee.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ExpectedPackagedAmount">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ExpectedPackagedAmount.displayControl.styles.style"
          [ngClass]="row.cells.ExpectedPackagedAmount.displayControl.styles.classes"
          [matTooltip]="row.cells.ExpectedPackagedAmount.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ExpectedPackagedAmount.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ActualPackagedAmount">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ActualPackagedAmount.displayControl.styles.style"
          [ngClass]="row.cells.ActualPackagedAmount.displayControl.styles.classes"
          [matTooltip]="row.cells.ActualPackagedAmount.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ActualPackagedAmount.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ActualPackaging">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ActualPackaging.displayControl.styles.style"
          [ngClass]="row.cells.ActualPackaging.displayControl.styles.classes"
          [matTooltip]="row.cells.ActualPackaging.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ActualPackaging.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="WarehouseName">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.WarehouseName.displayControl.styles.style"
          [ngClass]="row.cells.WarehouseName.displayControl.styles.classes"
          [matTooltip]="row.cells.WarehouseName.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.WarehouseName.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Notes">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Notes.displayControl.styles.style"
          [ngClass]="row.cells.Notes.displayControl.styles.classes"
          [matTooltip]="row.cells.Notes.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Notes.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ActualSourceLocation">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ActualSourceLocation.displayControl.styles.style"
          [ngClass]="row.cells.ActualSourceLocation.displayControl.styles.classes"
          [matTooltip]="row.cells.ActualSourceLocation.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ActualSourceLocation.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ActualTargetLocation">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ActualTargetLocation.displayControl.styles.style"
          [ngClass]="row.cells.ActualTargetLocation.displayControl.styles.classes"
          [matTooltip]="row.cells.ActualTargetLocation.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ActualTargetLocation.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ExpectedSourceLocation">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ExpectedSourceLocation.displayControl.styles.style"
          [ngClass]="row.cells.ExpectedSourceLocation.displayControl.styles.classes"
          [matTooltip]="row.cells.ExpectedSourceLocation.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ExpectedSourceLocation.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ExpectedTargetLocation">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ExpectedTargetLocation.displayControl.styles.style"
          [ngClass]="row.cells.ExpectedTargetLocation.displayControl.styles.classes"
          [matTooltip]="row.cells.ExpectedTargetLocation.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ExpectedTargetLocation.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="CreatedDateTime">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.CreatedDateTime.displayControl.styles.style"
          [ngClass]="row.cells.CreatedDateTime.displayControl.styles.classes"
          [matTooltip]="row.cells.CreatedDateTime.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.CreatedDateTime.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="CreatedBy">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.CreatedBy.displayControl.styles.style"
          [ngClass]="row.cells.CreatedBy.displayControl.styles.classes"
          [matTooltip]="row.cells.CreatedBy.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.CreatedBy.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ModifiedDateTime">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ModifiedDateTime.displayControl.styles.style"
          [ngClass]="row.cells.ModifiedDateTime.displayControl.styles.classes"
          [matTooltip]="row.cells.ModifiedDateTime.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ModifiedDateTime.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ModifiedBy">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.ModifiedBy.displayControl.styles.style"
          [ngClass]="row.cells.ModifiedBy.displayControl.styles.classes"
          [matTooltip]="row.cells.ModifiedBy.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.ModifiedBy.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>

<ng-template expandableRowDef
              let-row>
    <FootprintManager-shipping_container_tasks_child_grid
    [shippingContainerId]="row.$rowExpand_FootprintManager_shipping_container_tasks_child_grid_inParams_shippingContainerId"
    [chainHead]="row.$rowExpand_FootprintManager_shipping_container_tasks_child_grid_inParams_chainHead"
    ($refreshEvent)="row.refresh()">>
  </FootprintManager-shipping_container_tasks_child_grid>
</ng-template>

</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
